import {computed, signal} from "@preact/signals-react";
import {isEmpty} from "@ui-seeker/utils";

import {isLoadingCommonFilters} from "@signals";


export const adminProductReviewHeaderTableData = signal([])
export const adminProductReviewTableData = signal([])
export const adminProductReviewDetailsData = signal([])
export const adminProductReviewDetails = signal({})
export const optionsSelect = signal([])
export const filteredRetailers = signal([])
export const retailerSelected = signal([])
export const adminProductReviewItemsData = signal([])
export const adminProductReviewSkuMappingData = signal([])

export const adminProductReviewShowTable = computed(() => !isLoadingCommonFilters.value && adminProductReviewTableData.value.length)
export const adminProductReviewShowDetails = computed(() => !isEmpty(adminProductReviewDetails.value))
export const adminProductReviewShowItemsData = computed(() => !!adminProductReviewItemsData.value.length)